import PropTypes from 'prop-types';
import {
  mobileHeaderMessages,
  mobileHeaderScope,
} from '../components/AppBottomNavigation/messages';
import {
  appBannerMessages,
  appBannerScope,
} from '../components/AppPromotionBanner/messages';
import {
  appUpdateWallMessages,
  appUpdateWallScope,
} from '../components/AppUpdateWall/messages';
import {
  submitButtonMessages,
  submitButtonScope,
} from '../components/ButtonSubmit/messages';
import {
  destinationCardMessages,
  destinationCardScope,
} from '../components/DestinationCard/messages';
import {
  detailedTripMessages,
  detailedTripScope,
} from '../components/DetailedTrip/messages';
import {
  discountCardCalculatorMessages,
  discountCardCalculatorScope,
} from '../components/DiscountCardCalculator/messages';
import {
  dropzoneMessages,
  dropzoneScope,
} from '../components/Dropzone/messages';
import {
  errorMessagemessages,
  errorMessageScope,
} from '../components/ErrorMessage/messages';
import { expandMessages, expandScope } from '../components/Expand/messages';
import { footerMessages, footerScope } from '../components/Footer/messages';
import { funnelMessages, funnelscope } from '../components/Funnel/messages';
import {
  MaintenanceMessages,
  maintenanceScope,
} from '../components/Maintenance/messages';
import { navbarMessages, navbarScope } from '../components/Navbar/messages';
import {
  newModalMessage,
  newModalScope,
} from '../components/NewModal/messages';
import {
  nextDayMessages,
  nextDayScope,
} from '../components/NextDay/messages.js';
import {
  nextSalesOpeningMessages,
  nextSalesOpeningScope,
} from '../components/NextSalesOpening/messages';
import {
  passengersMessages,
  passengersScope,
} from '../components/Passengers/messages';
import {
  presaleWarningMessages,
  presaleWarningScope,
} from '../components/PresaleWarning/messages';
import {
  priceCalendarMessages,
  priceCalendarScope,
} from '../components/PriceCalendar/messages';
import { ratingMessages, ratingScope } from '../components/Rating/messages';
import {
  salesOpeningTableMessages,
  salesOpeningTableScope,
} from '../components/SalesOpeningTable/messages';
import {
  translationBannerMessages,
  translationBannerScope,
} from '../components/TranslationBanner/messages';
import {
  travelSearchBarMessages,
  travelSearchBarScope,
} from '../components/TravelSearchBar/messages';
import { tripMessages, tripScope } from '../components/Trip/messages';
import {
  tripComparatorMessages,
  tripComparatorScope,
} from '../components/TripComparator/messages';
import {
  tripRecapMessages,
  tripRecapScope,
} from '../components/TripRecap/messages';
import {
  tripSimpleMessages,
  tripSimpleScope,
} from '../components/TripSimple/messages.js';
import {
  trustBoxMessages,
  trustBoxScope,
} from '../components/TrustBox/messages';
import { aboutMessages, aboutScope } from '../containers/About/messages';
import {
  accountProfileMessages,
  accountProfileScope,
} from '../containers/AccountProfile/messages';
import {
  ancillaryPurchaseMessages,
  ancillaryPurchaseScope,
} from '../containers/AncillaryPurchase/messages';
import { appMessages, appScope } from '../containers/App/messages';
import {
  buyDiscountCardMessages,
  buyDiscountCardScope,
} from '../containers/BuyDiscountCard/messages';
import { cityMessages, cityScope } from '../containers/City/View/messages';
import {
  companyMessages,
  companyScope,
} from '../containers/Company/View/messages';
import {
  confirmationMessages,
  confirmationScope,
} from '../containers/Confirmation/messages';
import { faqMessages, faqScope } from '../containers/Faq/View/messages';
import {
  giftCardMessages,
  giftCardScope,
} from '../containers/GiftCard/messages';
import { giftPotMessages, giftPotScope } from '../containers/GiftPot/messages';
import {
  groupTravelMessages,
  groupTravelScope,
} from '../containers/GroupTravel/messages';
import { homepageScope } from '../containers/HomePage/View/constants';
import { homepageMessages } from '../containers/HomePage/View/messages';
import {
  howItWorksMessages,
  howItWorksScope,
} from '../containers/howItWorks/messages';
import {
  largeTravelSliderMessages,
  largeTravelSliderScope,
} from '../containers/LargeTravelSlider/View/messages';
import {
  legalMentionMessages,
  legalMentionScope,
} from '../containers/LegalMention/messages';
import { loginMessages, loginScope } from '../containers/Login/messages';
import {
  mountainMessages,
  mountainScope,
} from '../containers/Mountain/View/messages';
import {
  newsletterMessages,
  newsletterScope,
} from '../containers/Newsletter/messages';
import {
  notFoundPageMessages,
  notFoundPageScope,
} from '../containers/NotFoundPage/messages';
import { ordersScope } from '../containers/Orders/constants';
import { ordersMessages } from '../containers/Orders/View/messages.js';
import {
  partnersMessages,
  partnersScope,
} from '../containers/Partners/View/messages';
import {
  passengersInfoMessages,
  passengersInfoScope,
} from '../containers/PassengersInfo/messages';
import { privacyMessages, privacyScope } from '../containers/Privacy/messages';
import {
  redirectMessages,
  redirectScope,
} from '../containers/Redirect/View/messages';
import {
  resultsMessages,
  resultsScope,
} from '../containers/Results/View/messages';
import {
  searchMetaMessages,
  searchMetaScope,
} from '../containers/Search/helpers/metaMessages';
import {
  searchMessages,
  searchScope,
} from '../containers/Search/View/messages';
import {
  searchHeaderMessages,
  searchHeaderScope,
} from '../containers/SearchHeader/messages';
import {
  stationMessages,
  stationMessagesScope,
} from '../containers/Station/View/messages';
import {
  stationSitemapMessages,
  stationSitemapScope,
} from '../containers/StationSitemap/View/messages';
import { supportMessages, supportScope } from '../containers/Support/messages';
import {
  supportV2Messages,
  supportV2Scope,
} from '../containers/SupportV2/messages';
import {
  termsOfSalesMessages,
  termsOfSalesScope,
} from '../containers/TermsOfSales/messages';
import {
  tsbMessages,
  tsbScope,
} from '../containers/TravelSearchBar/View/messages';

const getTranslation = (messages, scope, locale) => {
  const translation = {};
  /* eslint-disable no-return-assign */
  Object.entries(messages).map(
    (entry) => (translation[`${scope}.${entry[0]}`] = entry[1][locale]),
  );
  /* eslint-enable */
  return translation;
};

export const formattedMessagePropTypes = PropTypes.shape({
  de: PropTypes.string.isRequired,
  defaultMessage: PropTypes.string.isRequired,
  en: PropTypes.string.isRequired,
  es: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  it: PropTypes.string.isRequired,
  nl: PropTypes.string.isRequired,
});

const getFullTranslations = (locale) => ({
  ...getTranslation(passengersMessages, passengersScope, locale),
  ...getTranslation(expandMessages, expandScope, locale),
  ...getTranslation(destinationCardMessages, destinationCardScope, locale),
  ...getTranslation(homepageMessages, homepageScope, locale),
  ...getTranslation(largeTravelSliderMessages, largeTravelSliderScope, locale),
  ...getTranslation(redirectMessages, redirectScope, locale),
  ...getTranslation(resultsMessages, resultsScope, locale),
  ...getTranslation(tsbMessages, tsbScope, locale),
  ...getTranslation(notFoundPageMessages, notFoundPageScope, locale),
  ...getTranslation(legalMentionMessages, legalMentionScope, locale),
  ...getTranslation(termsOfSalesMessages, termsOfSalesScope, locale),
  ...getTranslation(partnersMessages, partnersScope, locale),
  ...getTranslation(ratingMessages, ratingScope, locale),
  ...getTranslation(detailedTripMessages, detailedTripScope, locale),
  ...getTranslation(appBannerMessages, appBannerScope, locale),
  ...getTranslation(newsletterMessages, newsletterScope, locale),
  ...getTranslation(aboutMessages, aboutScope, locale),
  ...getTranslation(appMessages, appScope, locale),
  ...getTranslation(accountProfileMessages, accountProfileScope, locale),
  ...getTranslation(groupTravelMessages, groupTravelScope, locale),
  ...getTranslation(howItWorksMessages, howItWorksScope, locale),
  ...getTranslation(faqMessages, faqScope, locale),
  ...getTranslation(privacyMessages, privacyScope, locale),
  ...getTranslation(cityMessages, cityScope, locale),
  ...getTranslation(companyMessages, companyScope, locale),
  ...getTranslation(searchMessages, searchScope, locale),
  ...getTranslation(searchMetaMessages, searchMetaScope, locale),
  ...getTranslation(mountainMessages, mountainScope, locale),
  ...getTranslation(stationMessages, stationMessagesScope, locale),
  ...getTranslation(stationSitemapMessages, stationSitemapScope, locale),
  ...getTranslation(ordersMessages, ordersScope, locale),
  ...getTranslation(tripSimpleMessages, tripSimpleScope, locale),
  ...getTranslation(nextDayMessages, nextDayScope, locale),
  ...getTranslation(trustBoxMessages, trustBoxScope, locale),
  ...getTranslation(submitButtonMessages, submitButtonScope, locale),
  ...getTranslation(newModalMessage, newModalScope, locale),
  ...getTranslation(supportMessages, supportScope, locale),
  ...getTranslation(supportV2Messages, supportV2Scope, locale),
  ...getTranslation(MaintenanceMessages, maintenanceScope, locale),
  ...getTranslation(travelSearchBarMessages, travelSearchBarScope, locale),
  ...getTranslation(funnelMessages, funnelscope, locale),
  ...getTranslation(tripMessages, tripScope, locale),
  ...getTranslation(tripRecapMessages, tripRecapScope, locale),
  ...getTranslation(confirmationMessages, confirmationScope, locale),
  ...getTranslation(passengersInfoMessages, passengersInfoScope, locale),
  ...getTranslation(stationMessages, stationMessagesScope, locale),
  ...getTranslation(footerMessages, footerScope, locale),
  ...getTranslation(priceCalendarMessages, priceCalendarScope, locale),
  ...getTranslation(errorMessagemessages, errorMessageScope, locale),
  ...getTranslation(tripComparatorMessages, tripComparatorScope, locale),
  ...getTranslation(dropzoneMessages, dropzoneScope, locale),
  ...getTranslation(searchHeaderMessages, searchHeaderScope, locale),
  ...getTranslation(navbarMessages, navbarScope, locale),
  ...getTranslation(loginMessages, loginScope, locale),
  ...getTranslation(buyDiscountCardMessages, buyDiscountCardScope, locale),
  ...getTranslation(giftCardMessages, giftCardScope, locale),
  ...getTranslation(giftPotMessages, giftPotScope, locale),
  ...getTranslation(ancillaryPurchaseMessages, ancillaryPurchaseScope, locale),
  ...getTranslation(presaleWarningMessages, presaleWarningScope, locale),
  ...getTranslation(translationBannerMessages, translationBannerScope, locale),
  ...getTranslation(nextSalesOpeningMessages, nextSalesOpeningScope, locale),
  ...getTranslation(
    discountCardCalculatorMessages,
    discountCardCalculatorScope,
    locale,
  ),
  ...getTranslation(salesOpeningTableMessages, salesOpeningTableScope, locale),
  ...getTranslation(mobileHeaderMessages, mobileHeaderScope, locale),
  ...getTranslation(appUpdateWallMessages, appUpdateWallScope, locale),
});
export { getFullTranslations };
